import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `http://oheaven.cn/${item.href}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-sm py-3">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && (
              <span className="text-foreground-400">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </div>
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}